<script lang="ts">
	import { ContentPage } from '@pages';
	import { Head } from '@atoms';
	import { onMount } from 'svelte';

	const { data } = $props();
</script>

<Head data={data.page._seoMetaTags}></Head>

<ContentPage data={data.page} />
